import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type ContactLogEntry,
  type LogContactParams,
} from "../../../../pending-confirmation/domain/entities/pending-confirmation";
import { type UndeliveredDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/** Records a call from "No entregado". It writes the same bitácora "Por
 *  confirmar" writes, so the customer's contact history stays in one place. */
export const logContact = createAsyncThunk<
  ContactLogEntry,
  LogContactParams,
  { dispatch: UndeliveredDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LOG_CONTACT, async (params, { extra }) => {
  return await extra.contactCenterRepo.logContact(params);
});
